import { Stack } from '@mui/material';
import { FC } from 'react';
import { PageContainer } from '../../components/Layout/PageContainer';
import { SOURCING_SEARCH_MOCK_DATA } from './data/sourcingSearchMockData';
import { PREVIEW_SAVED_SEARCH, PREVIEW_SOURCING_LIST } from './sourcing.fixtures';
import { SourcingGrid } from './SourcingGrid';
import { SourcingHeader } from './SourcingHeader';
import { HeaderActions } from './SourcingHeaderActions';

export const sourcingPageContainerSx = { padding: '0 1.5rem 1rem', height: '100%' };

const ignore = () => undefined;

interface SourcingPreviewProps {
  /** A saved search refreshes itself, so its header offers Run Now instead of enrichment. */
  savedSearch?: boolean;
  /** The list the sidebar has selected; the sample list's name otherwise. */
  name?: string;
}

/** The live list header and result grid over a sample list or saved search, while the module is frosted. */
export const SourcingPreview: FC<SourcingPreviewProps> = ({ savedSearch = false, name }) => {
  const sample = savedSearch ? PREVIEW_SAVED_SEARCH : PREVIEW_SOURCING_LIST;
  const list = name ? { ...sample, name } : sample;

  return (
    <Stack width='100%' height='100%' minHeight={0}>
      <SourcingHeader selectedList={list} onSaveTitle={ignore}>
        <HeaderActions
          listType={list.listType}
          entityType={list.entityType}
          onDownloadCsv={ignore}
          onMenuButtonClick={ignore}
          onEnrichNow={ignore}
          isEnrichLoading={false}
          onRunNow={ignore}
          isRunLoading={false}
          onBulkUpload={ignore}
          isBulkUploadLoading={false}
          onAddCompany={ignore}
          isAddingCompany={false}
        />
      </SourcingHeader>
      <PageContainer sx={sourcingPageContainerSx}>
        <SourcingGrid
          entityType='company'
          rowData={[...SOURCING_SEARCH_MOCK_DATA]}
          pagination
          paginationPageSize={25}
        />
      </PageContainer>
    </Stack>
  );
};
